import { palette } from './palette';

export type ActivityFilter = 'all' | 'dispatch' | 'task' | 'estop' | 'takeover';

const TABS: { key: ActivityFilter; label: string }[] = [
  { key: 'all', label: 'ALL' },
  { key: 'dispatch', label: 'DISPATCH' },
  { key: 'task', label: 'TASK' },
  { key: 'estop', label: 'STOP' },
  { key: 'takeover', label: 'TAKEOVER' },
];

export function TabFilter({
  value,
  onChange,
}: {
  value: ActivityFilter;
  onChange: (v: ActivityFilter) => void;
}) {
  return (
    <div
      className="inline-flex gap-1 rounded-lg p-1"
      style={{ background: palette.bgAlt }}
    >
      {TABS.map((t) => {
        const active = value === t.key;
        return (
          <button
            key={t.key}
            onClick={() => onChange(t.key)}
            className="rounded-md px-3 py-1.5 text-[10px] font-bold tracking-[0.14em] transition-colors"
            style={{
              background: active ? palette.good : 'transparent',
              color: active ? '#fff' : palette.muted,
            }}
          >
            {t.label}
          </button>
        );
      })}
    </div>
  );
}
